import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'
import i18n from './i18n'
import { init as initFS } from '@fullstory/browser'
import getGoogleAnalyticsSettings from './utils/googleAnalytics'
import './registerServiceWorker'
// PROJECT FONTS USING WEBFONTLOADER
import './plugins/web-font-loader'

import './plugins/objectEntriesPolyfill'

import 'emerald-workbench/dist/emerald.pagarme.min.css'

if (['pagarme'].includes(process.env.VUE_APP_THEME)) {
  store.dispatch('loadEmeraldByTheme', process.env.VUE_APP_THEME)
}

if (['production'].includes(process.env.VUE_APP_CORE_ENV)) {
  initFS({ orgId: 'BKP05' })

  const googleAnalyticsSettings = getGoogleAnalyticsSettings()
  Vue.use(VueGtag, googleAnalyticsSettings, router)
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
